/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/ExecutionHeader.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Displays the execution workspace header.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Back Navigation
 * ✓ Work Number
 * ✓ Work Title
 * ✓ Future Action Menu
 *
 ******************************************************************************/

import React from "react";
import { useNavigate } from "react-router-dom";

export default function ExecutionHeader({

    work,

}) {

    const navigate =
        useNavigate();

    return (

        <div
            className="card border-0 shadow-sm mb-4"
            style={{

                background:
                    "linear-gradient(90deg,#0d6efd,#4f8cff)",

                color: "#fff",

                borderRadius: 12,

            }}
        >

            <div className="card-body">

                <div className="d-flex justify-content-between align-items-start">

                    <div>

                        <button

                            className="btn btn-sm btn-light mb-3"

                            onClick={() => navigate(-1)}

                        >

                            <i className="fas fa-arrow-left me-2" />

                            Back

                        </button>

                        <div
                            className="text-white-50"
                            style={{
                                fontSize: 13,
                            }}
                        >

                            {work?.work_no}

                        </div>

                        <h3
                            className="mb-0"
                            style={{
                                fontWeight: 600,
                            }}
                        >

                            {work?.title}

                        </h3>

                    </div>

                    <button

                        className="btn btn-light"

                        title="More Actions"

                    >

                        <i className="fas fa-ellipsis-v" />

                    </button>

                </div>

            </div>

        </div>

    );

}